import api from "../../services/api";
import { getUserFactoryId } from '../../../index';

export async function getStructureTreeDesativadas() {
    const factoryId = getUserFactoryId();
    const retorno = await api.get(`structure/TreesByFactoryDesativadas/${factoryId}`);
    return retorno.data
}